export enum RecordingStateEnum {
    isNew = 0,
    isPlanned = 1,
    isCurrentlyRecording = 2,
    isRecorded = 3,
}
